export default __webpack_public_path__ + "static/media/carousel-item-01.ec76a169.png";